import { actionTypes } from "../app/modules/Auth/_redux/authRedux";
import * as util from "../app/popleads/app/functions/util";
import {
  REQUEST_ID_HEADER,
  isPopleadsRequest,
  newRequestId,
  recordFailedRequest,
} from "../app/popleads/components/Chat/assistantErrorCapture";


export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const authToken = util.getCookieValue(util.getCookieName());

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }

      /* The id the backend files a failure under, so "Ask the assistant" can name the request
         rather than describe it. PopLeads requests only: it is meaningless to anyone else. */
      if (isPopleadsRequest(config)) {
        config.headers[REQUEST_ID_HEADER] = newRequestId();
      }

      return config;
    },
    err => Promise.reject(err)

  );

  //PopLeads change
  axios.interceptors.response.use((response) => {
    /* PopLeads also says no with a 200: the body's stat is nok and the screen toasts its text. */
    if (response?.data?.stat === "nok") {
      recordFailedRequest({ config: response.config, status: response.status, message: response.data.text });
    }
    return response;
  }, (error) => {
    // eslint-disable-next-line no-console
    console.log("Request Error = ", error);
    recordFailedRequest({
      config: error?.config,
      status: error?.response?.status,
      message: error?.response?.data?.text || error?.message,
    });
    if (error && error.response && error.response.status === 401) {
      //util.eraseCookie(util.getCookieName());
      store.dispatch({ type: actionTypes.Logout });
    }
    return Promise.reject(error);
  });

}
